<template>
    <main class="page-main">
        <Breadcrumbs>
            <template slot="li">
                <li>/<span> Search Voucher</span></li>
            </template>
        </Breadcrumbs>

        <div class="block">
            <div class="container">
                <div class="title center">
                    <h1>Search Voucher</h1>
                </div>
            </div>
        </div>

        <div class="block">
            <div class="container">
                <SearchData
                    :route="$route.path + '/'"
                    :searchByFields="searchableFields"
                    :defaultSearchField="seachField"
                    :tableFields="tableFields">

                    <template slot="vouchers-used" slot-scope="{ data }">
                        <span v-if="data.voucher.used == 1">
                            <span class="icon icon-check check" style="color: green"></span>
                        </span>
                        <span v-else>
                            <span class="icon icon-close-1 cross" style="color: red"></span>
                        </span>
                    </template>

                    <template slot="vouchers-revoked" slot-scope="{ data }">
                        <span v-if="data.voucher.revoked == 1">
                            <span class="icon icon-check check" style="color: green"></span> by
                            {{ data.voucher.usr_revoke ? 'User' : 'CRON' }}
                        </span>
                        <span v-else>
                            <span class="icon icon-close-1 cross" style="color: red"></span>
                        </span>
                    </template>

                    <template slot="options" slot-scope="{ data }">
                        <VoucherOptions :voucher="data.voucher" @onError="error = $event"></VoucherOptions>
                    </template>
                </SearchData>

                <div v-if="error" class="alert alert-danger" style="text-align: center">{{ error }}</div>
            </div>
        </div>
    </main>
</template>

<script>
import axios from 'axios'
import Loading from '../../mixins/components/Loading'
import Modal from '../../mixins/components/Modal'
import SearchData from '../../mixins/components/SearchComponent'
import VoucherOptions from './plugins/Actions'

export default {
    name: "VoucherSearch",
    components: {
        Loading, Modal, SearchData, VoucherOptions
    },
    data () {
        return {
            loading: false,
            searchableFields: [
                {
                    name: 'code',
                    label: 'Voucher Code',
                    active: true
                }
            ],
            tableFields: [
                {
                    label: 'Voucher Code',
                    name: 'data.voucher.code',
                    isBold: true,
                    slot: ''
                },
                {
                    label: 'Points',
                    name: 'data.voucher.value',
                    isBold: false,
                    slot: ''
                },
                {
                    label: 'Sent',
                    name: 'data.voucher.sent',
                    isBold: false,
                    slot: ''
                },
                {
                    label: 'Used',
                    name: '',
                    isBold: false,
                    slot: 'vouchers-used'
                },
                {
                    label: 'Is Revoked?',
                    name: '',
                    isBold: false,
                    slot: 'vouchers-revoked'
                },
                {
                    label: 'Modified',
                    name: 'data.voucher.updated_at',
                    isBold: false,
                    slot: ''
                },
            ],
            seachField: 'code',
            currentVoucher: {},
            searchVal: null,
            clients: [],
            showModal: false,
            error: null
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/vouchers/Search.vue